export enum EPromoInfoActions {
  setCommonDealDetailsModalId = 'promoInfo/setCommonDealDetailsModalId',
}
